import { useEffect, useState, useContext } from 'react';
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';
import { Link, Navigate } from 'react-router-dom';
import { useCheckout } from '../Context/CheckoutContext';
import '../css/Checkout/Checkout.css';
import ChecoutItems from '../Components/Checkout/ChecoutItems';
import { CartContext } from '../Context/CartProvider';
import PaymentButton from '../Components/Checkout/PaymentButton';

const Overview = () => {
  const { cart, price} = useContext(CartContext);
  
  const { order, shipping } = useCheckout();
  console.log(order);

  const FREE_SHIPPING_THRESHOLD = 50000;
  const SHIPPING_COST = order.shippingMethod === 'personal' ? 0 : 2159;
  const FREE_SHIPPING_ITEM_IDS = [46126, 46127, 46128, 46129, 46130];

  const [shippingPrice, setShippingPrice] = useState(SHIPPING_COST);

  useEffect(() => {
    console.log(price)
    if (!cart || cart.length === 0) {
      setShippingPrice(SHIPPING_COST);
      return;
    }

    const hasFreeShippingItem = cart.some(item =>
      FREE_SHIPPING_ITEM_IDS.includes(Number(item.id))
    );

    const newShipping =
      price >= FREE_SHIPPING_THRESHOLD || hasFreeShippingItem
        ? 0
        : SHIPPING_COST;

    setShippingPrice(newShipping);
  }, [cart, price]);

  if (!order) {
    return <Navigate to='/fizetes/szallitas' />;
  }

  return (
    <div className='checkout-container-wrapper'>
      <NavBar />
      <div className='checkout-container'>
        <div className='checkout-status'>
          <Link to='/kosar'>Kosár</Link>
          <Link to='/fizetes/szallitas'>Szállítás</Link>
          <Link to='/fizetes/osszegzes'>Összegzés</Link>
        </div>

        <div className='checkout-overview'>
          <div className='checkout-shipping-details'>
            <h1>Számlázási cím</h1>
            <p>Név: {order.name}</p>
            <p>Tax: {order.tax}</p>
            <p>Cégnév: {order.company_name}</p>
            <p>Cím: {order.address}</p>
            <p>Város: {order.city}</p>
            <p>Irányítószám: {order.zip}</p>
          </div>

          {shipping.name && (
            <div className='checkout-shipping-details'>
              <h1>Szállítási cím</h1>
              <p>Név: {shipping.name}</p>
              <p>Cím: {shipping.address}</p>
              <p>Város: {shipping.city}</p>
              <p>Irányítószám: {shipping.postcode}</p>
              <p>Telefonszám: {shipping.phone}</p>
            </div>
          )}

          <div className='checkout-details'>
            <h1>Termékek</h1>
            <div className='checkout-items'>
              {cart.length > 0 ? (
                cart.map((item) => (
                  <ChecoutItems key={item.id} item={item} />
                ))
              ) : (
                <h2>Nincs termék a kosárban</h2>
              )}

              {shippingPrice > 0 ? (
                <span> + Szállítás: {shippingPrice} Ft</span>
              ) : (
                <span> + Szállítás: Ingyenes szállítás</span>
              )}

              {order.payment === 'cash' && (
                <span> + Készpénzes fizetés: {order.plus} Ft</span>
              )}
            </div>

            <div className='checkout-total'>
              <p>
                Összesen:{' '}
                {price +
                  shippingPrice +
                  (order.payment === 'cash' ? order.plus : 0)}{' '}
                Ft
              </p>
            </div>
          </div>

          <PaymentButton
            invoice={order}
            shipping={order.pickupPoint ? order.pickupPoint : shipping}
            cart={cart}
            amount={
              price +
              shippingPrice +
              (order.payment === 'cash' ? order.plus : 0)
            }
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Overview;
